import PLATFORMS from "@/constants/Platforms";
import getPlatform from "@/helpers/getPlatform";

export function filterPackageInMobile(list) {
  if (getPlatform() === PLATFORMS.MOBILE) {
    return list.filter(item => item.qtdVeic === undefined || item.qtdVeic === 1);
  }

  return list;
}